import React from 'react';
import Helmet from "react-helmet";
import {config} from "../../config";

const ErrorNotFound = () => {

    return (
        <div className="page-not-found">
            <Helmet>
                {config.preTitle}Erreur 404{config.postTitle}
                <meta name="prerender-status-code" content="404" />
            </Helmet>
            <h2>404</h2>
            <span>- Page non trouvée -</span>
            <span>Désolé mais la page que vous recherchez n'existe pas.</span>
        </div>
    )
};

export default ErrorNotFound;